import { cn } from '@/lib/utils';

type Status = 'ACTIVE' | 'EXPIRING' | 'EXPIRED' | 'available' | 'occupied' | 'INACTIVE' | 'CANCELLED' | 'SUSPENDED';

interface StatusBadgeProps {
  status: Status;
  label?: string;
}

const statusConfig: Record<Status, { label: string; className: string }> = {
  ACTIVE: { label: 'Active', className: 'status-active' },
  EXPIRING: { label: 'Expiring', className: 'status-expiring' },
  EXPIRED: { label: 'Expired', className: 'status-expired' },
  available: { label: 'Available', className: 'status-available' },
  occupied: { label: 'Occupied', className: 'status-occupied' },
  INACTIVE: { label: 'Inactive', className: 'bg-muted text-muted-foreground' },
  CANCELLED: { label: 'Cancelled', className: 'status-cancelled' },
  SUSPENDED: { label: 'Suspendido', className: 'bg-destructive/10 text-destructive' },
};

export function StatusBadge({ status, label }: StatusBadgeProps) {
  const config = statusConfig[status];
  if(!config){
    console.warn(`No className defined for status: ${status}`);
  }
  return (
    <span className={cn("status-badge", config.className)}>
      {label || config.label}
    </span>
  );
}
